import { Alert, Button, Stack, Typography } from "@mui/material";
import { LoadingSpinner } from "@tngtech/tng-ui";
import { ContactDetailsWarning } from "tng-address-collection-shared/types/apiTypes.ts";
import { ClassificationReason } from "tng-address-collection-shared/types/classification.ts";
import { useTranslator } from "../i18n/translator.ts";

const classificationReasonTranslationKey = {
  typo_email_or_name: "classificationReasonTypoEmailOrName",
  mismatch_salutation: "classificationReasonMismatchSalutation",
} as const satisfies Record<ClassificationReason, string>;

type ContactDetailsConsistencyAlertProps = {
  warning: ContactDetailsWarning | undefined;
  isPlaceholderData: boolean;
  isConfirmPending: boolean;
  onConfirm: () => void;
};

export const ContactDetailsConsistencyAlert = ({
  warning,
  isPlaceholderData,
  isConfirmPending,
  onConfirm,
}: ContactDetailsConsistencyAlertProps) => {
  const translate = useTranslator();
  const reason = warning?.reason;
  const justification = warning?.justification;

  if (isPlaceholderData) {
    return (
      <Alert severity="warning">
        <Stack direction="row" justifyContent="center">
          <LoadingSpinner />
        </Stack>
      </Alert>
    );
  }

  return (
    <Alert severity="warning">
      <Stack spacing={1}>
        <Stack spacing={0.5}>
          {reason && (
            <Typography fontWeight={"medium"}>
              {translate(classificationReasonTranslationKey[reason])}
            </Typography>
          )}
          {justification && <Typography>{justification}</Typography>}
        </Stack>
        <Stack direction="row" justifyContent="flex-start">
          <Button
            type="button"
            variant="outlined"
            color="warning"
            onClick={onConfirm}
            disabled={isConfirmPending}
          >
            {translate("markContactDetailsCorrect")}
          </Button>
        </Stack>
      </Stack>
    </Alert>
  );
};
